import { useTranslation } from 'next-i18next';

import { logger } from '@zep/core-logger';

import {
  BoltFillIcon,
  CoinStackFillIcon,
  LogoutIcon,
  PenFillIcon,
  PersonStackFillIcon,
} from '@/icons';
import { type SidebarMenu } from '@/layout/SidebarLayout/Sidebar';
import { useUser } from '@/lib/auth';
import { formatEnglishTitleCase } from '@/utils/formatEnglishTitleCase';

export const useProfileSidebarMenu = () => {
  const { t, i18n } = useTranslation(['common']);
  const { logOut, user } = useUser();
  const isWorkspaceOwner = user?.workspace?.isPaidOwner ?? false;
  const formatLabel = (label: string) =>
    formatEnglishTitleCase(label, i18n.resolvedLanguage);

  const profileEditMenu: SidebarMenu = {
    label: formatLabel(t('common:detailProfile')),
    href: '/profile/edit',
    target: '_self',
    icon: PenFillIcon,
    onClick: () => {
      logger.track('click_profile_edit');
    },
  };

  const planMenu: SidebarMenu = {
    label: formatLabel(t('common:planManage')),
    href: '/profile/plan',
    target: '_self',
    icon: BoltFillIcon,
    onClick: () => {
      // click_voucher(이용권 메뉴) 지표에 플랜 관리 클릭이 섞이지 않도록 분리한 이벤트.
      logger.track('click_plan_manage');
    },
  };

  const pointMenu: SidebarMenu = {
    label: formatLabel(t('common:myPoints')),
    // `from` 은 도착 페이지의 진입 경로 트래킹용(quiz_point_history_view.place).
    href: '/profile/points?from=profile_sidebar',
    activeHrefs: ['/profile/points'],
    target: '_self',
    icon: CoinStackFillIcon,
    onClick: () => {},
  };

  const planMemberMenu: SidebarMenu = {
    label: formatLabel(t('common.plan.memberManage')),
    href: '/profile/plan-members',
    target: '_self',
    icon: PersonStackFillIcon,
    onClick: () => {
      logger.track('click_plan_member_manage');
    },
  };

  const footerMenus: SidebarMenu[] = [
    {
      label: t('common:header.logout'),
      href: null,
      target: null,
      onClick: () => {
        void logOut({ redirectTo: '/landing' });
        logger.track('enter_logout', {
          location: 'profile',
        });
      },
      icon: LogoutIcon,
    },
  ];

  return {
    menus: [
      profileEditMenu,
      ...(user?.type?.toLowerCase() === 'student' ? [pointMenu] : []),
      planMenu,
      ...(isWorkspaceOwner ? [planMemberMenu] : []),
    ],
    footerMenus,
  };
};
